export const systemProperties = {
	dateTimeFormat: 'HH:mm, DD/MM/YYYY',
	dateFormat: 'DD/MM/YYYY',
	phonePattern: /^((84|0[3|2|4|6|5|7|8|9])+([0-9]{8})\b)$/g,
	emailPattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/g,
	citizenIdentifyPattern: /^[0-9]{9}$|^[0-9]{12}$/g,
	passWord: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/g,
	userName: /^^(?=.{4,20}$)/g,
};